import React, { useEffect } from "react";
import { useTranslation } from "react-i18next";
import { Button, Typography } from "@mui/material";
import * as Sentry from "@sentry/nextjs";
import { PageContainer } from "styles/Unauthorized";

import { theme } from "@bxtech/bx-ui-lib";

import { Container } from "./styles";

const AppErrorFallback = ({
  error,
  resetErrorBoundary,
}: {
  error: Error;
  resetErrorBoundary: () => void;
}) => {
  const { t } = useTranslation();
  useEffect(() => {
    // Enhanced Sentry logging with more context
    Sentry.captureException(error, {
      tags: {
        component: "AppErrorFallback",
        errorType: "fallback_displayed",
      },
      extra: {
        errorMessage: error.message,
        errorStack: error.stack,
        // Avoid leaking tokens/PII via query/hash
        currentUrl: `${window.location.origin}${window.location.pathname}`,
        userAgent: navigator.userAgent,
        timestamp: new Date().toISOString(),
      },
    });
  }, [error]);

  return (
    <PageContainer>
      <Container>
        <Typography
          variant="h3"
          color="text.primary"
          align="center"
          style={{
            marginTop: theme.space(50),
            maxWidth: "547px",
            padding: `0 ${theme.space(40)}`,
          }}
        >
          {t("errors.somethingWentWrong.title")}
        </Typography>
        <Typography
          variant="body1"
          color="text.primary"
          align="center"
          style={{
            marginTop: theme.space(20),
            maxWidth: "547px",
            padding: `0 ${theme.space(40)}`,
          }}
        >
          {t("errors.somethingWentWrong.message")}
        </Typography>
        <Button
          type="button"
          onClick={() => {
            resetErrorBoundary();
            window.location.href = "/";
          }}
          variant="contained"
          sx={{ borderRadius: 12, marginTop: theme.space(20) }}
        >
          {t("common.buttons.returnHome")}
        </Button>
      </Container>
    </PageContainer>
  );
};

export default AppErrorFallback;
